module.exports = __webpack_public_path__ + "img/Catalina Evangelista Contreras_Recursos Humanos.b6ec5182.png";